export default __webpack_public_path__ + "static/media/LabReceived.ce3201e2.svg";